module.exports = __webpack_public_path__ + "img/logo.d8834e02.png";